import type { Messages } from './en'

export const fr: Messages = {
  'common.back': 'Retour',
  'common.opensInNewTab': 's’ouvre dans un nouvel onglet',
  'omnidek.openPortal': 'Ouvrir le portail Omnidek',
  'auth.signedOut': 'Vous avez été déconnecté.',
  'auth.login': 'Se connecter',

  'language.label': 'Choisir la langue',

  'nav.home': 'Accueil',
  'nav.calendar': 'Calendrier',
  'nav.training': 'Formation',
  'nav.profile': 'Profil',
  'nav.primary': 'Navigation principale',

  'splash.welcome': 'Bienvenue',
  'splash.loading': 'Chargement d’EDF SuperApp',

  // Accueil — variante prospect (salutation, accessibilité du carrousel, carte de contact).
  'home.greeting': 'Bon retour',
  'home.editName': 'Modifier le nom',
  'home.assetId': 'Asset ID',
  'home.carousel.label': 'À la une',
  'home.carousel.prev': 'Précédent',
  'home.carousel.next': 'Suivant',
  'home.carousel.goToSlide': 'Aller à la diapositive {number}',
  'home.carousel.slide1.alt': 'À la une 1',
  'home.carousel.slide2.alt': 'À la une 2',
  'home.carousel.slide3.alt': 'À la une 3',
  'home.contact.title': 'Nous contacter',
  'home.contact.body':
    'Une question ou besoin d’aide ? Notre équipe est là pour vous — écrivez-nous et nous vous répondrons rapidement.',
  'home.contact.cta': 'Écrivez-nous',
  'home.feature.title': 'Capital privé pour une croissance économique inclusive',
  'home.feature.cta': 'Terminer la demande',
  'home.apply.cta': 'TERMINER LA DEMANDE',
  'home.feature.imageAlt': 'Des parents souriants avec leur jeune fils sur les épaules de son père',

  'applicationStatus.title': 'Statut de la demande',
  'applicationStatus.overview': 'Aperçu',
  'applicationStatus.status.completed': 'Terminé',
  'applicationStatus.status.underReview': 'En cours d’examen',
  'applicationStatus.status.draft': 'Brouillon',
  'applicationStatus.status.actionRequired': 'Action requise',
  'applicationStatus.status.inProgress': 'En cours',
  'applicationStatus.card.nextSteps': 'Prochaines étapes',
  'applicationStatus.card.viewDetails': 'Voir les détails',
  'applicationStatus.card.continue': 'Continuer',

  'applicationOfInterest.title': 'Demande d’intérêt',

  'application.title': 'Demande KYC',
  'application.loading': 'Chargement de la demande KYC...',
  'upload.sectionNotOpen': "Cette section n'est pas encore ouverte aux téléversements.",
  'upload.docAlreadyPassed': 'Ce document a déjà été approuvé — aucun nouveau téléversement n’est nécessaire.',
  'upload.documentUnderReview':
    'Ce document est déjà en cours de révision. Si vous avez téléversé le mauvais fichier par erreur, veuillez contacter le support à support@economicdevelopmentfund.com.',
  'upload.invalidFileType':
    'Seuls les fichiers PDF et images (PNG, JPEG, WebP, GIF, BMP) sont pris en charge pour l’aperçu dans le navigateur. Veuillez téléverser un format accepté.',
  'upload.fileTooLarge': 'La taille du fichier dépasse la limite de 10 Mo. Veuillez téléverser un fichier plus petit.',
  'upload.budgetNotEditable': 'Ce budget est en cours de révision ou déjà approuvé.',
  'upload.invoiceNotConfirmed': 'Le téléversement de la facture n’a pas pu être confirmé. Veuillez réessayer.',
  'upload.invoiceOpenFailed': 'Impossible d’ouvrir la facture. Veuillez réessayer.',

  // KYC step gating on /apply — what shows instead of (or over) the form.
  'kyc.submitting': 'Envoi de votre demande...',
  'kyc.waiting.title': 'Vos documents sont en cours d’examen',
  'kyc.waiting.body':
    'Vous avez téléversé tout ce dont nous avons besoin pour le moment. Notre équipe examine vos documents — nous vous informerons dès qu’il y aura du nouveau ou une nouvelle étape à compléter.',
  'kyc.complete.title': 'Votre KYC est terminé',
  'kyc.complete.body':
    'Tous vos documents ont été examinés et approuvés. Il n’y a rien de plus à téléverser.',
  'kyc.failed.title': 'Un document nécessite votre attention',
  'kyc.failed.intro':
    'Le document suivant a été examiné et n’a pas pu être accepté. Veuillez en téléverser un nouveau.',
  'kyc.failed.noReason': 'Aucun motif n’a été fourni. Veuillez téléverser le document à nouveau.',
  'kyc.failed.continue': 'Continuer',
  'kyc.submitted.dialog.title': 'Demande reçue',
  'kyc.submitted.dialog.body':
    'Votre demande KYC et vos documents ont été soumis avec succès et sont actuellement en cours d’examen par notre équipe.',
  'kyc.submitted.dialog.viewStatus': 'Voir le statut de la demande',
  'kyc.submitted.dialog.done': 'Terminé',
  'kyc.panel.action.status': 'Voir le statut de la demande',
  'kyc.panel.action.home': 'Retour à l’accueil',

  'profile.logout': 'Se déconnecter',

  'pwa.install.banner.title': 'Obtenez l’application EDF',
  'pwa.install.banner.body': 'Un accès plus rapide et un raccourci sur votre écran d’accueil',
  'pwa.install.cta': 'Installer',
  'pwa.install.dismiss': 'Fermer',

  'stageBar.important.prefix': 'Important',
  'stageBar.apply.label': 'Terminez votre demande pour continuer',

  'nextStep.dialog.title': 'Prochaines étapes',
  'nextStep.dialog.nda.body':
    'Merci de l’intérêt que vous portez aux services de The Economic Development Fund. Afin de donner suite à votre intérêt, veuillez compléter, signer et soumettre l’accord de confidentialité (NDA).',
  'nextStep.dialog.kyc.body':
    'Merci de l’intérêt que vous portez aux services de The Economic Development Fund. Afin de poursuivre votre demande, veuillez compléter et soumettre le formulaire de connaissance du client (KYC).',
  'nextStep.dialog.close': 'Fermer',
  'nextStep.dialog.next': 'Suivant',
}
